

// v1.5 add group
import React, { useState, useEffect, useRef } from "react";
import GoogleMapReact from 'google-map-react';
import Marker from "./Marker";
import Header from "./Header";
import Card from './Card/Card'; // Assuming path - Please verify
// import Popup from './Card/Popup_v3'; // Assuming path - Please verify
import Popup from "./Card/Popup_v4";
import image from '../images/img_map-marker.png'; // Placeholder image path - Please verify
import { AppContainer } from "../App.styles2";
import axios from "axios";
import './HomePage.css'


// Import Slider components
import CustomSlider from "./Slider/CustomSlider";
import CustomSliderFullwidth from "./Slider/CustomSlider-fullwidth"; // Import new full-width slider
import CustomSliderHalfwidth from "./Slider/CustomSlider-halfwidth"; // Import new half-width slider
import CustomSliderThirdwidth from "./Slider/CustomSlider-thirdwidth";

import ReelDisplay from "./Reel/Reel";
import ExpandableCard from "./Reel/ExpandableCard";
import StellerPage from "./Reel/Stell";

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://comtruaduytan.com/api/markers/';

const handleGetRecommendations = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${apiBaseUrl}mapMarker/recommendations`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response.data);
        alert('Recommendations fetched successfully!');
    } catch (error) {
        console.error('Error getting recommendations:', error);
        alert('Error getting recommendations.');
    }
};

const HomePage_v1_3 = () => {
    const defaultProps = {
        center: {
            lat: 21.044175, // Center to San Francisco
            lng: 105.846411,
        },
        zoom: 10,
    };

    const [markers, setMarkers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedHeight, setExpandedHeight] = useState(100);//useState(95); // Use number for comparison, not string
    const [startTouchY, setStartTouchY] = useState(null);
    const [activeTab, setActiveTab] = useState('recommended'); // State for active tab
    const [activeProperty, setActiveProperty] = useState(null); // Added state
    const [showPopup, setShowPopup] = useState(false); // Added state
    const [isFiltering, setIsFiltering] = useState(false); // Added placeholder state
    const [propertiesList, setPropertiesList] = useState([]); // Added placeholder state (initialized empty, will use markers later)
    const [filterIsVisible, setFilterIsVisible] = useState(false); // Added placeholder state
    const [zoomLevel, setZoomLevel] = useState(defaultProps.zoom); // Added zoom level state

    const videoRef = useRef(null);

    const handleSlideClick = (file) => {
      // setActiveProperty({file: file});
      setActiveProperty(file);
      setShowPopup(true);
    };

   useEffect(() => {
        const setVH = () => {
          const vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--dvh', `${vh}px`);
        };

        setVH(); // Set on load
        window.addEventListener('resize', setVH);
        return () => window.removeEventListener('resize', setVH);
      }, []);

    // Placeholder functions - Implement logic as needed
    const toggleFilter = () => setFilterIsVisible(!filterIsVisible);
    const clearFilter = () => { console.log("Clear filter clicked"); };
    const handleFilterChange = (event) => { console.log("Filter changed:", event.target.value); };
    const handleCartItemClick = (property) => { console.log("Card clicked:", property); };

    // Fetch markers from the API
    const oldfetchMarkers = async () => {
        setLoading(true);
        setError(null);

        // Retrieve token from localStorage
        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(apiBaseUrl + 'own', {
                headers: {
                    Authorization: `Bearer ${token}`, // Add token to the Authorization header
                },
            });

            const fetchedMarkers = response.data;
            setMarkers(fetchedMarkers); // Update the state with fetched markers
            setPropertiesList(fetchedMarkers); // Initialize propertiesList with fetched markers
        } catch (error) {
            // setError('Error fetching markers');
            // console.error('Error fetching markers:', error);
            // Check if the error is due to 401 Unauthorized
            if (error.response && error.response.status === 401) {
                setError('Hãy đăng nhập');
                // Optionally, you can redirect to the login page here
                // window.location.href = '/login'; // Uncomment this line if you want to redirect
            } else {
                setError('Error fetching markers');
            }
            console.error('Error fetching markers:', error);

        } finally {
            setLoading(false);
        }
    };



    // 1) dynamically inject the Nunito font once
    // useEffect(() => {
    //   const link = document.createElement('link');
    //   link.href =
    //     'https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap';
    //   link.rel = 'stylesheet';
    //   document.head.appendChild(link);
    // }, []);

    // helper to show a styled <p> with optional position overrides
    const fetchMarkers = async () => {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem('token');

      try {
        const response = await axios.get(`${apiBaseUrl}own`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const fetchedMarkers = response.data;
        setMarkers(fetchedMarkers);
        setPropertiesList(fetchedMarkers);
      } catch (err) {
        const style = {
          fontFamily: "'Nunito', sans-serif",
          // fontSize: "1rem",
          fontWeight: 900,
          // color: "#d32f2f",
          // textAlign: "left",
          // right: "-100% !important",             // shifts the box 10% from the left edge
          // top: "-0px",             // adjust as needed

          margin: "1em 2",
          fontFamily: "'Nunito', sans-serif",
          fontSize: "20px",
          // textShadow: "-1px -1px 2px rgba(255,255,255,0.8),  1px 1px 2px rgba(0,0,0,0.3)", // shadow top left and bottom right
          textShadow: "0px 0px 2px rgba(0,0,0,0.8)",
        };

        if (err.response?.status === 401) {
          setError(
            <p style={style}>
              Hãy đăng nhập
            </p>
          );
        } else {
          setError(
            <p style={style}>
              Error fetching markers
            </p>
          );
        }

        console.error("Error fetching markers:", err);
      } finally {
        setLoading(false);
      }
    };


    useEffect(() => {
        fetchMarkers(); // Fetch markers when component mounts
        console.log('##### markers ######')
        console.log(markers)
    }, []);

    // Handlers for swipe interactions
    const handleTouchStart = (e) => {
        const touchStart = e.touches[0].clientY;
        setStartTouchY(touchStart);
    };

    const handleTouchMove = (e) => {
        if (startTouchY === null) return; // Ignore if no touch started
        const touchMove = e.touches[0].clientY;
        const diff = startTouchY - touchMove; // Calculate the difference in vertical movement
        const newHeight = Math.max(0, expandedHeight + diff * 2); // Prevent negative height values, increase sensitivity
        setExpandedHeight(newHeight); // Dynamically change height
        setStartTouchY(touchMove); // Update start position for smooth movement
    };

    const handleTouchEnd = () => {
        if (expandedHeight > 80) {
            // setExpandedHeight(95); // Expand to 50%
            setExpandedHeight(100); // Expand to 50%
        } else if (expandedHeight < 80) {
            setExpandedHeight(40); // Collapse to 33%
        }
        setStartTouchY(null); // Reset touch position
    };

    // Toggle between showing text or not on click
    const handleToggleText = (id) => {
        setMarkers((prevMarkers) => {
            return prevMarkers.map((marker) => {
                if (marker._id === id) {
                    return {
                        ...marker,
                        showText: !marker.showText, // Toggle text visibility
                    };
                }
                return marker;
            });
        });
    };

    return (
        <AppContainer>
          <Header />
          <div className="app" 
            style={{ 
              height: "100dvh",//"100vh",  
              width: "100%", 
              // position: "relative",
              position: "absolute",
              top: '0px', 
              overflowY: "hidden",
              overflowX: "hidden",
            }}>
            {/* Google Map */}
            <GoogleMapReact
                // bootstrapURLKeys={{ key: "AIzaSyDfnY7GcBdHHFQTxRCSJGR-AGUEUnMBfqo" }} // Ensure your API key is valid

                bootstrapURLKeys={{ key: "" }} // Ensure your API key is valid

                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                yesIWantToUseGoogleMapApiInternals
                options={{
                    gestureHandling: 'greedy',
                }}
                style={{
                    position: "absolute",
                    top: "-12%",
                    left: "-45%",
                    width: "150%",
                    height: `calc(100dvh - ${expandedHeight}dvh + 14dvh )` // Map height adjusts with expanded area
                }}
            >
                {loading ? (
                    <p>Loading markers...</p>
                ) : error ? (
                    <p
                    style={{
                        color: '#fefefe',        // Red color for the error text
                        fontSize: '15px',    // Increase the font size
                        textAlign: 'left', // Center-align the text
                        marginLeft: '0px',
                        // padding: '20px',     // Add padding around the text
                        // backgroundColor: 'rgba(255, 0, 0, 0.1)', // Light red background
                        // borderRadius: '8px', // Rounded corners
                        // maxWidth: '80%',     // Max width for better responsiveness
                        // margin: '20px auto', // Center the error box horizontally
                        // fontWeight: 'bold'   // Make the text bold
                    }}
                >
                    {error}
                </p>
                ) : (
                    markers.map((marker) => (
                        <Marker
                            key={marker._id} // Ensure each marker has a unique key
                            lat={marker.location.coordinates[0]} // Latitude at index 0
                            lng={marker.location.coordinates[1]} // Longitude at index 1
                            text={marker.title} // Title of the marker
                        />
                    ))
                )}
            </GoogleMapReact>



            {/* Expanded Area */}
            <div
                style={{
                    position: "absolute",
                    // bottom: "30px", // Adjust to stay above the swipeable bar
                    // bottom: "6dvh", 
                    bottom: "0dvh", 
                    left: "0",
                    width: "100%",
                    height: `${expandedHeight}dvh`, // Dynamic height based on expandedHeight state
                    backgroundColor: "#fefefe",
                    // overflowY: "auto", // <-- Remove this
                    overflowX: "hidden", // Disable horizontal scrolling
                    transition: "height 0.3s ease-in-out", // Smooth transition for height change
                    // Add flexbox styles
                    minHeight: '50dvh',
                    display: 'flex',
                    flexDirection: 'column',
                    borderTopLeftRadius: "20px", // Rounded top left corner
                    borderTopRightRadius: "20px", // Rounded top right corner
                    // boxShadow: "0px -1px 10px rgba(0,0,0,0.1)",
                    borderTop: "1px solid rgba(0,0,0,0.03)",
                    // border:" 1px solid transparent",

                    zIndex: 10001, // Ensure it's beneath the swipeable bar
                }}
            >

              {/* Swipeable Horizontal Bar */}
              <div
                  style={{
                      // position: "absolute",
                      position: "sticky",
                      top: "0%", // Always at the bottom of the expanded area
                      left: "0",
                      width: "100%",
                      height: "20px", // Fixed height for the swipeable bar
                      backgroundColor: "#fefefe",
                      cursor: "pointer",
                      zIndex: 10,
                  }}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
              >
                  <div
                      style={{
                          position: "absolute",
                          // position: "sticky",
                          width: "40px",
                          height: "5px",
                          backgroundColor: "#D3D3D3",
                          // backgroundColor: "#000",
                          borderRadius: "3px",
                          top: "60%",
                          left: "50%",
                          transform: "translateX(-50%) translateY(-50%)",
                      }}
                  ></div>
              </div>

              {/* Navigation Bar */}
              <div 
                style={{
                    display: 'flex',
                    justifyContent: 'space-around', // 'flex-start', //'center', //
                    // gap: '-4px', // Smaller gap between items
                    // transform: 'translateX(-20px)', // Move slightly left or right


                    // padding: '5px 0',
                    borderBottom: '1px solid #e0e0e055',
                    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    backgroundColor: '#fefefe', // Match handle background
                    // backgroundColor: "rgba(255, 255, 255, 0.75)", /* Semi-transparent background */
                    // backdropFilter: "blur(35px)",
                    // WebkitBackdropFilter: "blur(35px)",                  
                    position: 'sticky',// 'absolute', // // Make nav sticky below handle
                    // top: '48px', // Position below the handle (adjust if handle height changes)
                    zIndex: 9 // Below handle, above content
                }}
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}                
              >

                {/* Posts (Lock) - Keyhole with Rectangle */}
                <div
                  onClick={() => setActiveTab('recommended')}
                  style={{ background: 'none', border: 'none', 
                    padding: '5px 10px', 
                    cursor: 'pointer', color: activeTab === 'recommended' ? 'black' : '#999' }}
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {/* Lock Body */}
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                    {/* Shackle */}
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    {/* Keyhole Elements (Solid Fill - Circle + Rectangle) */}
                    {/* Circle part of the keyhole */}
                    <circle cx="12" cy="15" r="1.5" fill="currentColor" stroke="none"></circle>
                    {/* Rectangle part extending down from the circle */}
                    {/* Starts slightly above circle bottom edge (y=16.5) to ensure connection */}
                    <rect x="11" y="15" width="2" height="4" fill="currentColor" stroke="none"></rect>
                  </svg>
                </div>

                {/* Sliders Icon - Adjusted Line Lengths & Arrow */}
                <div
                  onClick={() => setActiveTab('posts')}
                  style={{ background: 'none', border: 'none', padding: '5px 10px', cursor: 'pointer', color: activeTab === 'posts' ? 'black' : '#999' }}
                >
                  {/* SVG with 6 vertical lines in 2 rows and a down triangle slightly higher */}
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {/* Vertical Lines - Row 1 */}
                    <line x1="4" y1="5" x2="4" y2="10" />
                    <line x1="9" y1="5" x2="9" y2="10" />
                    <line x1="14" y1="5" x2="14" y2="10" />
                    {/* Vertical Lines - Row 2 */}
                    <line x1="4" y1="13" x2="4" y2="18" />
                    <line x1="9" y1="13" x2="9" y2="18" />
                    <line x1="14" y1="13" x2="14" y2="18" />
                    {/* Downward SOLID Triangle - Moved slightly higher */}
                    {/* Path starts at y=11 now */}
                    {/* <path d="M 20 11 l -3 4 l 6 0 Z" fill="currentColor" stroke="none" /> */}
                    {/* <path d="M 20 11 l -3 4 l 6 0 Z" fill="currentColor" stroke="none" /> */}
                    <path d="M 20 15 l -3 -4 l 6 0 Z" fill="currentColor" stroke="none" />

                    {/* <path d="M18 15 l4 4 l4 -4 Z" fill="currentColor" stroke="none"></path>  */}
                    {/* Adjusted triangle position/size */}

                  </svg>
                </div>

                {/* Reels (Refresh Arrows) - Seems to match well, keeping original */}
                <div
                  onClick={() => setActiveTab('reels')}
                  style={{ background: 'none', border: 'none', padding: '5px 10px', cursor: 'pointer', color: activeTab === 'reels' ? 'black' : '#999' }}
                >
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="23 4 23 10 17 10" />
                    <polyline points="1 20 1 14 7 14" />
                    <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10" />
                    <path d="M20.49 15A9 9 0 0 1 9.36 18.64L1 14" />
                  </svg>
                </div>

                {/* Bookmark + Plus Icon (Replacing Comments Bubble) */}
                <div
                  onClick={() => setActiveTab('comments')} // Keep onClick key for now
                  style={{ background: 'none', border: 'none', padding: '5px 10px', cursor: 'pointer', color: activeTab === 'comments' ? 'black' : '#999' }}
                >
                  {/* SVG for Bookmark shape with Plus */}
                  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {/* Bookmark ribbon shape path */}
                    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                    {/* Plus sign lines inside */}
                    <line x1="12" y1="7" x2="12" y2="13"></line> {/* Vertical line */}
                    <line x1="9" y1="10" x2="15" y2="10"></line> {/* Horizontal line */}
                  </svg>
                </div>

                {/* Heart + Plus Icon (Replacing Likes Heart) */}
                <div
                  // onClick={() => alert('likes')}
                  onClick={() => setActiveTab('likes')} // Keep onClick key for now
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: '5px 10px',
                    cursor: 'pointer',
                    color: '#999',
                    position: 'relative',
                    display: 'inline-block',
                  }}
                >
                  {/* Heart SVG */}
                  <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ display: 'block' }}
                  >
                    <path d="M20.8 4.6c-1.5-1.4-3.9-1.4-5.4 0L12 8l-3.4-3.4c-1.5-1.4-3.9-1.4-5.4 0-1.5 1.5-1.5 3.9 0 5.4l8.8 8.8 8.8-8.8c1.5-1.5 1.5-3.9 0-5.4z" />
                  </svg>
                  {/* Plus sign right against the heart */}
                  <svg
                    viewBox="0 0 24 24"
                    width="11"
                    height="11"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                      position: 'absolute',
                      top: '1px',
                      right: '4px',
                      pointerEvents: 'none',
                    }}
                  >
                    <line x1="5" y1="12" x2="19" y2="12" /> {/* Horizontal */}
                    <line x1="12" y1="5" x2="12" y2="19" /> {/* Vertical */}
                  </svg>
                </div>

              </div>

              {/* Expanded Content */}
              {expandedHeight > 0 && (
                  <div
                      style={{
                          flex: 1, // Take up remaining space in the flex column
                          overflowY: 'auto', // Add scrolling here
                          // padding: '0px 5px 0px 5px', // Keep padding
                          
                      }}
                  >

                      {/* <FlickityCarousel ></FlickityCarousel>
                      <br/> <br/>
                      <FlickityCarousel2 ></FlickityCarousel2>
                      <br/> <br/>
                      <FlickityCarousel3 ></FlickityCarousel3>
                      <br/> <br/> */}
                      <div className="main-container"
                              style={{
                                display: 'flex',
                                // justifyContent: 'center', // Center Horizontally
                                // Optional Vertical Centering:
                                // alignItems: 'center',
                                // minHeight: '400px', // Adjust as needed for vertical centering
                                width: '100%', // Usually needed
                                // height: '50%',
                                margin: '0px',
                                overflowY: 'hidden', // Add scrolling here
                                

                              }}
                      >
                          {activeTab === 'recommended' && (
                              <div>
                                  {/* Original Custom Slider */}
                                  {/* <div style={{ marginBottom: '20px' }}>
                                      <h3>Original Slider</h3>
                                      <CustomSlider />
                                  </div> */}



                                  {/* New Third Width Slider for group */}
                                  <div 
                                  style={{ 
                                    marginBottom: '20px',
                                  }}
                                  
                                  > {/* Add margin between posts */}

                                    {/* Heading */}
                                    <h3 style={{
                                      marginBottom: '2px', // Reduce default space below the heading
                                      // Add other heading styles if needed (fontSize, fontWeight, color)
                                      fontSize: '1.4rem', // Example: Match SliderSection title style
                                      fontWeight: 'bold',
                                      color: '#000',
                                      paddingLeft: '10px',
                                      fontWeight: '800',
                                      WebkitTextStroke: '1px black',
                                    }}>
                                      {/* Artists */}
                                      Group
                                    </h3>

                                    {/* Subtitle - Added this <p> element */}
                                    <p style={{
                                      fontSize: '0.9rem',     // Smaller font size like the reference image
                                      color: '#777',         // Lighter gray color
                                      marginTop: '0',         // Remove default top margin from <p>
                                      marginBottom: '15px',   // Add space below the subtitle, before the slider
                                      paddingLeft: '10px'      // Optional: slight indent if needed
                                    }}>
                                      {/* pick your champion */}
                                      join like-minded people
                                    </p>

                                    {/* Slider Component */}
                                    <CustomSliderThirdwidth onSlideClick={handleSlideClick} />


                                  </div>
                                  
                                  {/* New Full Width Slider */}
                                  <div style={{ marginBottom: '20px' }}> {/* Add margin between posts */}

                                    {/* Heading */}
                                    <h3 style={{
                                      marginBottom: '2px', // Reduce default space below the heading
                                      // Add other heading styles if needed (fontSize, fontWeight, color)
                                      fontSize: '1.4rem', // Example: Match SliderSection title style
                                      fontWeight: 'bold',
                                      color: '#000',
                                      paddingLeft: '10px',
                                      fontWeight: '800',
                                      // fontWeight: 'bold',
                                      // textShadow: '0px 0px 1px black',
                                      WebkitTextStroke: '1px black',


                                    }}>
                                      {/* Hosts */}
                                      Gallery
                                    </h3>

                                    {/* Subtitle - Added this <p> element */}
                                    <p style={{
                                      fontSize: '0.9rem',     // Smaller font size like the reference image
                                      color: '#777',         // Lighter gray color
                                      marginTop: '0',         // Remove default top margin from <p>
                                      marginBottom: '15px',   // Add space below the subtitle, before the slider
                                      paddingLeft: '10px'      // Optional: slight indent if needed
                                    }}>
                                      {/* choose your spotlight */}
                                      find something amusing

                                    </p>


                                      {/* Render CustomSliderFullwidth - ensure it takes full width */}
                                      <CustomSliderFullwidth />
                                  </div>

                                  {/* New Half Width Slider */}
                                  <div style={{ marginBottom: '20px' }}> {/* Add margin between posts */}

                                    {/* Heading */}
                                    <h3 style={{
                                      marginBottom: '2px', // Reduce default space below the heading
                                      // Add other heading styles if needed (fontSize, fontWeight, color)
                                      fontSize: '1.4rem', // Example: Match SliderSection title style
                                      fontWeight: 'bold',
                                      color: '#000',
                                      paddingLeft: '10px',
                                      // fontWeight: '9000 !important',
                                      // fontWeight: 'bold !important',
                                      // textShadow: '0px 0px 1px black',
                                      WebkitTextStroke: '1px black',

                                    }}>
                                      {/* Events */}
                                      Other people
                                    </h3>

                                    {/* Subtitle - Added this <p> element */}
                                    <p style={{
                                      fontSize: '0.9rem',     // Smaller font size like the reference image
                                      color: '#777',         // Lighter gray color
                                      marginTop: '0',         // Remove default top margin from <p>
                                      marginBottom: '15px',   // Add space below the subtitle, before the slider
                                      paddingLeft: '10px'      // Optional: slight indent if needed
                                    }}>
                                      {/* make your moment */}
                                      explore the community
                                    </p>

                                      {/* Render CustomSliderHalfwidth */}
                                      <CustomSliderHalfwidth />
                                      
                                  </div>


                                  {/* New Third Width Slider */}
                                  <div 
                                  style={{ 
                                    marginBottom: '20px',
                                  }}
                                  
                                  > {/* Add margin between posts */}

                                    {/* Heading */}
                                    <h3 style={{
                                      marginBottom: '2px', // Reduce default space below the heading
                                      // Add other heading styles if needed (fontSize, fontWeight, color)
                                      fontSize: '1.4rem', // Example: Match SliderSection title style
                                      fontWeight: 'bold',
                                      color: '#000',
                                      paddingLeft: '10px',
                                      fontWeight: '800',
                                      WebkitTextStroke: '1px black',
                                    }}>
                                      {/* Artists */}
                                      Friends
                                    </h3>

                                    {/* Subtitle - Added this <p> element */}
                                    <p style={{
                                      fontSize: '0.9rem',     // Smaller font size like the reference image
                                      color: '#777',         // Lighter gray color
                                      marginTop: '0',         // Remove default top margin from <p>
                                      marginBottom: '15px',   // Add space below the subtitle, before the slider
                                      paddingLeft: '10px'      // Optional: slight indent if needed
                                    }}>
                                      {/* pick your champion */}
                                      see what they've been doing
                                    </p>

                                    {/* Slider Component */}
                                    <CustomSliderThirdwidth onSlideClick={handleSlideClick} />


                                  </div>
                                  
                                  <div style={{ height: "10dvh", background: "white" }}></div>

                                  {/* {showPopup && activeProperty && (
                                    <Popup property={activeProperty} setShowPopup={() => setShowPopup(false)} />
                                    // <div
                                    //   style={{
                                    //     position: "fixed",    // or “absolute” if that fits your layout
                                    //     top: 0,
                                    //     left: 0,
                                    //     width: "100vw",
                                    //     height: "100vh",
                                    //     display: "flex",      // center child if you want
                                    //     alignItems: "center",
                                    //     justifyContent: "center",
                                    //     zIndex: 10005,         // higher than everything else
                                    //     background: "rgba(0,0,0,0.5)" // optional backdrop
                                    //   }}
                                    // >
                                    //   <Popup



                                    //     property={activeProperty}
                                    //     setShowPopup={() => setShowPopup(false)}
                                    //   />
                                    // </div>

                                  )} */}


                              </div>
                          )}

                          {activeTab === 'posts' && (
                              <div className="homepage-listings" style={{
                                  // height: `${expandedHeight}vh`, // <-- Remove this
                                  border: '1px solid transparent'
                              }}>
                                {/* --- DEBUG LOGS START --- */}
                                {console.log('Rendering Posts Tab Content. Expanded Height:', expandedHeight)}
                                {console.log('Markers data:', markers)}
                                {/* --- DEBUG LOGS END --- */}
                                {/* Note: This Header instance might need different props than the main one */}
                                {/* <Header
                                  filterIsVisible={filterIsVisible}
                                  toggleFilter={toggleFilter}
                                  clearFilter={clearFilter}
                                  handleFilterChange={handleFilterChange}
                                /> */}
                                <div className="cards container">
                                  {/* Using 'markers' state as the source for cards */}
                                    {/* Modified to display 3 rectangular cards per row */}
                                    <div className={`cards-list row row-cols-3 ${markers.length === 0 ? 'is-empty' : ''}`}>
                                      {markers.map((marker, index) => {
                                        // Adjusted logic for 3 items per row
                                        const rowIndex = Math.floor(index / 3);
                                        // Set isDoubleHeight to true to ensure cards are rectangular.
                                        // This assumes that isDoubleHeight=true makes the card rectangular.
                                        const isRectangular = true;

                                        return (
                                          <Card
                                            key={marker._id}
                                            property={marker}
                                            activeProperty={activeProperty}
                                            setActiveProperty={setActiveProperty}
                                            setShowPopup={setShowPopup}
                                            isDoubleHeight={isRectangular} // Set to true to make them rectangular
                                            onCartItemClick={handleCartItemClick}
                                            setZoomLevel={setZoomLevel} // Pass setZoomLevel
                                          />
                                        );
                                      })}
                                    </div>

                                  {/* Using isFiltering state and markers length for */}
                                  {isFiltering && markers.length === 0 && (
                                    <p className="warning">
                                      <img src={image} alt="No properties were found." />
                                      <br />
                                      No properties were found.
                                    </p>
                                  )}

                                  {/* {showPopup && activeProperty && (
                                    <Popup property={activeProperty} setShowPopup={setShowPopup} />
                                  )} */}
                                </div>

                                <div style={{ height: "10dvh", background: "white" }}></div>


                              </div>
                          )}

                          {activeTab === 'reels' && (
                            <>
                              <ReelDisplay/>
                              <button onClick={handleGetRecommendations}>Get Recommendations</button>
                              <div style={{ height: "10dvh", background: "white" }}></div>

                            </>
                              // <div>Reels Content Here</div> // Placeholder
                          )}

                          {activeTab === 'comments' && (
                            <ExpandableCard/>
                              // <div>Reels Content Here</div> // Placeholder
                          )}
                          {activeTab === 'likes' && (
                            <StellerPage/>
                              // <div>Reels Content Here</div> // Placeholder
                          )}

                      </div>




                  </div>
              )}

              {/* <br/>
              <br/>
              <br/>
              <br/> */}

            </div>

            {showPopup && activeProperty && (
              <Popup property={activeProperty} setShowPopup={setShowPopup} />
            )}

          </div>
        </AppContainer>
    );
};

export default HomePage_v1_3; // Updated export name
